import React from 'react';
import moment from 'moment';
import { titleize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import { getRequestFields } from './accessorialRequestPaneUtils';
import {
  renderUnits,
  renderRate,
  renderDeclineCode,
  renderNotes,
} from './accessorialInfoHelpers';

const AccessorialInfo = ({
  accessorial,
  referenceAccessorial,
  actions,
  isCarrier,
  dataTestId,
}) => {
  const { t } = useTranslation();
  const { rate, units, beginDate, endDate, location, description, notes } =
    getRequestFields(accessorial, isCarrier);
  const {
    currency,
    vendor,
    vendor_name,
    decline_reason_code: declineReasonCode,
  } = accessorial;

  return (
    <div data-testid={dataTestId} className="">
      <div
        data-testid="div-5d4714ca"
        className="flex items-start justify-between"
      >
        <div data-testid="div-789cfb7d" className="flex flex-1 gap-4">
          <div data-testid="div-467616c7" className="flex-1">
            {renderUnits(t, units, referenceAccessorial)}
          </div>
          <div data-testid="div-7b80a64e" className="flex-1">
            {renderRate(t, rate, currency)}
          </div>
        </div>
        <div data-testid="div-17102e4a" className="flex-shrink-0">
          {actions()}
        </div>
      </div>
      <div data-testid="div-ee43b029" className="flex flex-wrap gap-4">
        {isCarrier && vendor && (
          <div data-testid="div-a35e73de" className="flex-1 mt-4">
            <label
              data-testid="label-8c7bb271"
              htmlFor=""
              className="block mb-1 form-label"
            >
              {titleize(t('VENDOR', { count: 1 }))}
            </label>
            <p data-testid="p-bc4a0aa4" className="mb-0 text-sm">
              {vendor_name}
            </p>
          </div>
        )}
        {beginDate && (
          <div data-testid="div-5c5c61be" className="flex-1 mt-4">
            <label
              data-testid="label-10704074"
              htmlFor=""
              className="block mb-1 form-label"
            >
              {t('BEGIN_DATE')}
            </label>
            <p data-testid="p-f3b216e0" className="mb-0 text-sm">
              {moment(beginDate).format('MMM Do YYYY')}
            </p>
            <p data-testid="p-4f90f59b" className="text-sm">
              {moment(beginDate).format('hh:mm A')}
            </p>
          </div>
        )}
        {endDate && (
          <div data-testid="div-27a5d17a" className="flex-1 mt-4">
            <label
              data-testid="label-8ca94da4"
              htmlFor=""
              className="block mb-1 form-label"
            >
              {t('END_DATE')}
            </label>
            <p data-testid="p-09e62149" className="mb-0 text-sm">
              {moment(endDate).format('MMM Do YYYY')}
            </p>
            <p data-testid="p-2f260081" className="text-sm">
              {moment(endDate).format('hh:mm A')}
            </p>
          </div>
        )}
        {location && (
          <div data-testid="div-09896939" className="flex-1 mt-4">
            <label
              data-testid="label-51ea4f9c"
              className="block mb-1 form-label"
            >
              {t('LOCATION')}
            </label>
            <p data-testid="p-ad7f5ce6">{titleize(location)}</p>
          </div>
        )}
        {description && (
          <div data-testid="div-67884963" className="flex-1 mt-4">
            <label
              data-testid="label-9570d608"
              htmlFor=""
              className="block mb-1 form-label"
            >
              {t('DESCRIPTION', { count: 1 })}
            </label>
            <p data-testid="p-ed58d238">{description}</p>
          </div>
        )}
      </div>
      {declineReasonCode && (
        <div data-testid="div-98f1773d" className="mt-4">
          {renderDeclineCode(t, declineReasonCode)}
        </div>
      )}
      <div data-testid="div-4f67244f" className="mt-4">
        {renderNotes(t, notes, isCarrier)}
      </div>
    </div>
  );
};

export default AccessorialInfo;
